import { lazy } from "react";

import { SPORTBOOK_ROUTES } from "../container/SportsBookNode/utils/common/routes";

export const SPORTS_ROUTE = [
  {
    path: SPORTBOOK_ROUTES.MYBETS,
    component: lazy(() => import("../container/SportsBookNode/pages/MyBets")),
    private: true,
    version: 2
  },
  {
    path: SPORTBOOK_ROUTES.RESULT,
    component: lazy(() => import("../container/SportsBookNode/pages/Result")),
    private: false,
    version: 2
  },
  {
    path: SPORTBOOK_ROUTES.FAVOURITES,
    component: lazy(
      () => import("../container/SportsBookNode/pages/Favorites")
    ),
    private: true,
    version: 2
  },
  {
    path: SPORTBOOK_ROUTES.EXTRAMARKET,
    component: lazy(
      () => import("../container/SportsBookNode/pages/ExtraMarkets")
    ),
    private: false,
    version: 2
  },
  {
    path: SPORTBOOK_ROUTES.HOME + ":sportId",
    component: lazy(
      () => import("../container/SportsBookNode/pages/SportsBookHome")
    ),
    private: false,
    version: 2
  },
  {
    path: SPORTBOOK_ROUTES.SPORTS,
    component: lazy(
      () => import("../container/SportsBookNode/pages/SportsBookHome")
    ),
    private: false,
    version: 2
  },
  //Adding same route for achiving previous sportbook routes to open with new
  {
    path: SPORTBOOK_ROUTES.MYBETS2,
    component: lazy(() => import("../container/SportsBookNode/pages/MyBets")),
    private: true,
    version: 1
  },
  {
    path: SPORTBOOK_ROUTES.RESULT2,
    component: lazy(() => import("../container/SportsBookNode/pages/Result")),
    private: false,
    version: 1
  },
  {
    path: SPORTBOOK_ROUTES.FAVOURITES2,
    component: lazy(
      () => import("../container/SportsBookNode/pages/Favorites")
    ),
    private: true,
    version: 1
  },
  {
    path: SPORTBOOK_ROUTES.EXTRAMARKET2,
    component: lazy(
      () => import("../container/SportsBookNode/pages/ExtraMarkets")
    ),
    private: false,
    version: 1
  },
  {
    path: SPORTBOOK_ROUTES.HOME2 + ":sportId",
    component: lazy(
      () => import("../container/SportsBookNode/pages/SportsBookHome")
    ),
    private: false,
    version: 1
  },
  {
    path: SPORTBOOK_ROUTES.SPORTS2,
    component: lazy(
      () => import("../container/SportsBookNode/pages/SportsBookHome")
    ),
    private: false,
    version: 1
  }
  //   {
  //     path: "sports",
  //     component: lazy(() => import("../container/SportsBook/SportsBookHome")),
  //     private: false,
  //     version: 1
  //   },
  //   {
  //     path: "market/:sportName/:sportId/:matchType/:matchId",
  //     component: lazy(() => import("../container/SportsBook/ExtraMarkets")),
  //     private: false,
  //     version: 1
  //   },
  //   {
  //     path: "sports/calendar",
  //     component: lazy(() =>
  //       import("../container/SportsBook/SportsBookHome/UpcomingEvents/Calendar")
  //     ),
  //     private: false,
  //     version: 1
  //   },
  //   {
  //     path: "live",
  //     component: lazy(() =>
  //       import("../container/SportsBook/SportsBookHome/Live")
  //     ),
  //     private: false,
  //     version: 1
  //   },
  //   {
  //     path: "result",
  //     component: lazy(() => import("../container/SportsBook/Result")),
  //     private: false,
  //     version: 1
  //   },
  //   {
  //     path: "search",
  //     component: lazy(() =>
  //       import("../container/SportsBook/SportsBookHome/Sb_Search")
  //     ),
  //     private: false,
  //     version: 1
  //   },
  //   {
  //     path: ":sportName/:sportId/:locationName?/:locationId?/:leagueName?/:leagueId?",
  //     component: lazy(() => import("../container/SportsBook/SingleSportPage")),
  //     private: false,
  //     version: 1
  //   },
  //   {
  //     path: "/sportsbook",
  //     component: lazy(() => import("../container/SportsBook/Layouts")),
  //     private: false,
  //     version: 1
  //   },
  //   {
  //     path: "favorites",
  //     component: lazy(() => import("../container/SportsBook/FavouriteList")),
  //     private: true,
  //     version: 1
  //   },
  //   {
  //     path: "mybets",
  //     component: lazy(() => import("../container/SportsBook/Mybets")),
  //     private: true,
  //     version: 1
  //   }
];

export const APP_ROUTES = [
  {
    path: "/:referralCode",
    component: lazy(() => import("../components/NotASubscriber")),
    private: false
  },
  {
    path: "/cms/:id/:name",
    component: lazy(() => import("../components/Footer/Cms")),
    private: false
  },
  {
    path: "/user/verifyEmail",
    component: lazy(() => import("../components/VerifyEmail")),
    private: false
  },
  {
    path: "/user/forgotPassword",
    component: lazy(() => import("../components/ForgotPassword")),
    private: false
  },
  {
    path: "/faq",
    component: lazy(() => import("../components/Faq")),
    private: false
  },
  {
    path: "/casinoProvider",
    component: lazy(
      () => import("../container/Casino/Lobby/CasinoProvider/index")
    ),
    private: false
  },
  {
    path: "/sports",
    component: lazy(
      () => import("../container/SportsBookNode/IframeSportsBook/index")
    ),
    private: false
  }
];

export const CASINO_PRIVATE_ROUTES = [
  {
    path: "/game/:gameId",
    component: lazy(() => import("../container/Casino/IframeGame")),
    private: false
  },
  {
    path: "/provider-lobby/:providerId",
    component: lazy(() => import("../container/Casino/IframeGame")),
    private: false
  },
  {
    path: "favorites",
    component: lazy(() => import("../container/Casino/Favorites")),
    private: false
  }
];

export const SIDEBAR_ROUTES = [
  {
    path: "*",
    component: lazy(() => import("../components/NotASubscriber")),
    private: false
  },
  {
    path: "myProfile",
    component: lazy(() => import("../components/User/MyProfile")),
    private: false
  },
  {
    path: "transaction",
    component: lazy(() => import("../components/User/Transaction")),
    private: false
  },
    {
    path: "bonus",
    component: lazy(() => import("../components/User/Bonus")),
    private: false
  },
  {
    path: "resetPassword",
    component: lazy(() => import("../components/User/ResetPassword")),
    private: false
  },
  {
    path: "betHistory",
    component: lazy(() => import("../components/User/BetHistory")),
    private: false
  }
];

export const CASINO_ROUTES = [
  {
    path: "casino-lobby",
    component: lazy(() => import("../container/Casino/Lobby")),
    private: false
  },
  {
    path: "casinoProvider",
    component: lazy(
      () => import("../container/Casino/Lobby/CasinoProvider/index")
    ),
    private: false
  },
  {
    path: "casino_favorites",
    component: lazy(() => import("../container/Casino/Favorites")),
    private: false
  },
  {
    path: "view-all/:filter/:id/:name/:subCategory?/",
    component: lazy(() => import("../container/Casino/ViewAll")),
    private: false
  },
  {
    path: "view-all/topgames",
    component: lazy(() => import("../container/Casino/Lobby/TopGamesViewAll")),
    private: false
  },
  {
    path: "casinoLive",
    component: lazy(() => import("../container/Casino/LiveCasino")),
    private: false
  },
  {
    path: "slotGame",
    component: lazy(() => import("../container/Casino/Slots")),
    private: false
  },
  {
    path: "*",
    component: lazy(() => import("../components/NotASubscriber")),
    private: false
  },
  {
    path: "on-fire",
    component: lazy(() => import("../container/Casino/OnFire")),
    private: false
  },
  {
    path: "nuevos-juegos",
    component: lazy(() => import("../container/Casino/NewGames")),
    private: false
  },
  {
    path: "poker",
    component: lazy(() => import("../container/Casino/Poker")),
    private: false
  },
  {
    path: "baccarat",
    component: lazy(() => import("../container/Casino/Baccarat")),
    private: false
  },
  {
    path: "ruleta",
    component: lazy(() => import("../container/Casino/Roulette")),
    private: false
  }
];

export const parentRoutes = {
  sportsbookV2: {
    component: lazy(() => import("../container/SportsBookNode/pages/Layout"))
  },
  sportsbook: {
    component: lazy(() => import("../container/SportsBookNode/pages/Layout"))
  },
  sideBar: {
    component: lazy(() => import("../components/Sidebar"))
  },
  lobbySubHeader: {
    component: lazy(
      () => import("../container/Casino/Lobby/LobbySubheader/LobbySubheader")
    )
  }
};
